export default {
  en: {
    agent: "Agent",
    agents: "Agents",
    title: "Agents",
    agentDetails: "Agent Details",
    deployDescription:
      "Adversary profiles are collections of ATTA&CK TTPs, designed to create specific effects on a host or network. Profiles can be used for offensive or defensive use cases.",
    deploySelectAgent: "Select the Agent you want to use from the list",
    deploySelectAgentWindows: "Select the Windows TLS version",
    titleConfig: "Agents Parameters",
    close: "Close",
    save: "Save",
    platform: "Platform",
    createTitle: "Generate Agent Command",
    deployAgent: "Generate Agent",
    selectAgent: "Select your Agent",
    searchResults:
      "Your search resulted in <strong>{in}</strong> out of <strong>{outOf}</strong> agents",
    bulkActionsTitle: "Bulk Actions",
    bulkActions: {
      removeDeadAgents: "Remove inactive agents",
      removeAllAgents: "Remove all agents",
      killAllAgents: "Kill all agents"
    },
    fields: {
      sleepMinAndMax: "Beacon Timers (s)",
      sleepTimer: "Sleep Timer",
      watchdog: "Watchdog Timer (s)",
      untrustedTimer: "Unstrusted Timer (s)",
      nameSuggestion: "Implant Name",
      commandControl: "Command & Control",
      agentNamePlaceholder: "Insert Agent Name",
      agentNameFeedback: "this field is required"
    },
    modal: {
      buttonText: "Remove them",
      killAllAgents: {
        title: "Kill all agents",
        text: "Are you sure that you want to kill all you active agents?"
      },
      killAgent: {
        title: "Kill Agent",
        text: "Are you sure that you want to kill this active agent?",
        killButton: "Kill"
      },
      removeAllAgents: {
        title: "Remove all agents",
        text: "Are you sure that you want to remove all agents from you list?"
      },
      removeAgent: {
        title: "Remove agent",
        text: "Are you sure that you want to remove this agent from you list?",
        removeButton: "Remove"
      },
      removeDeadAgents: {
        title: "Remove inactive agents",
        text: "Are you sure that you want to remove all inactive agents from you list?"
      },
      successfullyDeployed: {
        title: "Agent '{agentName}' Successfully Deployed",
        text: "Your agent was able to make comunication back with us, it means that it is alive and ready to work."
      },
      failedToDeploy: {
        title: "Agent '{agentName}' Failed to Deployed",
        text: "Your agent was unable to make comunication back with us, it means that it had problems and could not be activated, try it again.<br><br>Make sure you’re using the right code for the correct OS with Admin privileges.",
        deployAgainButton: "Deploy Again"
      }
    },
    warning: "* A global setting that will effect any new or existing agents.",
    commandCopy: {
      cta: "Copy Code",
      title: "Code copied to clipboard",
      text: "The code you copied should be pasted on target’s <b><u>{terminal}</u></b> and executed using <b><u>administrator privileges</u></b> to start agent comunication"
    },
    commandDownload: {
      cta: "Download",
      title: "Your code download has started",
      text: "The code you downloaded must have executable privileges with the command <b>chmod +x ./filename.sh</b> and then be executed to start communication with the agent."
    },
    viewCommand: "View Command"
  },
  pt: {
    agent: "Agente",
    agents: "Agentes",
    title: "Agentes",
    agentDetails: "Detalhes do agente",
    deployDescription:
      "Os perfis de adversários são coleções de ATTA&CK TTPs, projetados para criar efeitos específicos em um host ou rede. Os perfis podem ser usados para casos de uso ofensivo ou defensivo.",
    deploySelectAgent: "Selecione o agente que você deseja usar da lista",
    deploySelectAgentWindows: "Selecione a versão TLS do Windows",
    titleConfig: "Parâmetros dos Agentes",
    close: "Fechar",
    save: "Salvar",
    createTitle: "Gerar Comando de Agente",
    platform: "Plataforma",
    selectAgent: "Selecione o seu agente",
    deployAgent: "Gerar Agente",
    searchResults:
      "Sua busca resultou em <strong>{in}</strong> de <strong>{outOf}</strong> agentes",
    bulkActionsTitle: "Ações",
    bulkActions: {
      removeDeadAgents: "Remover agentes inativos",
      removeAllAgents: "Remover todos os agentes",
      killAllAgents: "Matar todos os agentes"
    },
    fields: {
      sleepMinAndMax: "Beacon Timers (s)",
      sleepTimer: "Sleep Timer",
      watchdog: "Watchdog Timer (s)",
      untrustedTimer: "Unstrusted Timer (s)",
      nameSuggestion: "Nome de Implantação",
      commandControl: "Command & Control",
      agentNamePlaceholder: "Insira o nome do Agente",
      agentNameFeedback: "este campo é obrigatório"
    },
    modal: {
      buttonText: "Removê-los",
      killAllAgents: {
        title: "Matar todos os Agentes",
        text: "Tem certeza que você quer matar todos os seus agentes ativos?"
      },
      killAgent: {
        title: "Matar Agente",
        text: "Tem certeza que você quer matar este Agente ativo?",
        killButton: "Matar"
      },
      removeAllAgents: {
        title: "Remover todos agentes",
        text: "Tem certeza que você deseja remover todos os agentes da lista?"
      },
      removeAgent: {
        title: "Remover Agente",
        text: "Tem certeza de que deseja remover esse agente da sua lista?",
        removeButton: "Remover"
      },
      removeDeadAgents: {
        title: "Remover todos os agentes inativos",
        text: "Tem certeza que você deseja remover todos os agentes inativos da lista?"
      },
      successfullyDeployed: {
        title: "Agente '{agentName}' Implantado com Sucesso",
        text: "Seu agente conseguiu se comunicar conosco, o que significa que ele está ativo e pronto para trabalhar."
      },
      failedToDeploy: {
        title: "Agente '{agentName}' Falhou ao ser Implantado",
        text: "Seu agente não conseguiu se comunicar conosco, isso significa que ele teve problemas e não pôde ser ativado, tente novamente.<br><br>Certifique-se de que está usando o código correto para o sistema operacional correto com privilégios de administrador.",
        deployAgainButton: "Implantar Novamente"
      }
    },
    warning:
      "* Um cenário global que irá afectar quaisquer agentes novos ou existentes.",
    commandCopy: {
      cta: "Copiar Código",
      title: "Código copiado para a área de transferência",
      text: "O código que você copiou deve ser colado no <b><u>{terminal}</u></b> do alvo e executado usando <b><u>privilégios de administrador</u></b> para iniciar a comunicação com o agente"
    },
    commandDownload: {
      cta: "Baixar",
      title: "O download do seu código foi iniciado",
      text: "O código que você baixou deve ter privilégios de executaveis com o comando <b>chmod +x ./nome_do_arquivo.sh</b>  e então ser executado para iniciar a comunicação com o agente"
    },
    viewCommand: "Visualizar Comando"
  },
  es: {
    agent: "Agente",
    agents: "Agentes",
    title: "Agents",
    agentDetails: "Detalles do agente",
    deployDescription:
      "Los perfiles de los adversarios son colecciones de TTPs ATTA&CK, diseñadas para crear efectos específicos en un host o red. Los perfiles pueden utilizarse para casos de uso ofensivo o defensivo.",
    deploySelectAgent: "Seleccione de la lista el Agente que desea utilizar",
    deploySelectAgentWindows: "Seleccione la versión TLS de Windows",
    titleConfig: "Parametros dos Agentes",
    close: "Fechar",
    save: "Salvar",
    createTitle: "Generar Comando de Agente",
    deployAgent: "Gerar Agente",
    selectAgent: "Selecione o seu agente",
    platform: "Plataforma",
    searchResults:
      "Su búsqueda ha resultado en <strong>{in}</strong> de <strong>{outOf}</strong> agentes",
    bulkActionsTitle: "Aciones",
    bulkActions: {
      removeDeadAgents: "Remove inactive agents",
      removeAllAgents: "Remove all agents",
      killAllAgents: "Kill all agents"
    },
    fields: {
      sleepMinAndMax: "Beacon Timers (s)",
      sleepTimer: "Sleep Timer",
      watchdog: "Watchdog Timer (s)",
      untrustedTimer: "Unstrusted Timer (s)",
      commandControl: "Command & Control",
      nameSuggestion: "Nombre de Despliegue",
      agentNamePlaceholder: "Introduzca el nombre del Agente",
      agentNameFeedback: "este campo es obligatorio"
    },
    modal: {
      buttonText: "Quítalos",
      killAllAgents: {
        title: "Matar a todos los agentes",
        text: "¿Estás seguro de que quieres matar a todos los agentes activos?"
      },
      killAgent: {
        title: "Matar agente",
        text: "¿Estás seguro de que quieres matar lo agente activo?",
        killButton: "Matar"
      },
      removeAllAgents: {
        title: "Eliminar todos los agentes",
        text: "¿Está seguro de que quiere eliminar todos los agentes de su lista?"
      },
      removeAgent: {
        title: "Eliminar agente",
        text: "¿Está seguro de que desea eliminar a este agente de su lista?",
        removeButton: "Eliminar"
      },
      removeDeadAgents: {
        title: "Eliminar los agentes inactivos",
        text: "¿Estás seguro de que quieres eliminar todos los agentes inactivos de tu lista?"
      },
      successfullyDeployed: {
        title: "Agente '{agentName}' Desplegado con Éxito",
        text: "Su agente ha conseguido comunicarse con nosotros, lo que significa que está activo y dispuesto a trabajar."
      },
      failedToDeploy: {
        title: "No se ha podido Desplegar el Agente '{agentName}'",
        text: "Su agente no ha podido volver a comunicarse con nosotros, significa que ha tenido problemas y no se ha podido activar, inténtelo de nuevo..<br><br>Asegúrese de que está utilizando el código correcto para el sistema operativo correcto con privilegios de administrador.",
        deployAgainButton: "Volver a Desplegar"
      }
    },
    warning:
      "* Um cenário global que irá afectar quaisquer agentes novos ou existentes.",
    commandCopy: {
      cta: "Copiar Código",
      title: "Código copiado en el portapapeles",
      text: "El código que ha copiado debe pegarse en la <b><u>{terminal}</u></b> de destino y ejecutarse con <b><u>privilegios de administrador</u></b> para iniciar la comunicación con el agente"
    },
    commandDownload: {
      cta: "Descargar",
      title: "Se ha iniciado la descarga de su código",
      text: "El código que ha descargado debe tener permisos de ejecución con el comando <b>chmod +x ./nombre_del_archivo.sh</b> y luego ser ejecutado para iniciar la comunicación con el agente."
    },
    viewCommand: "Ver Comando"
  }
}
